import { FC } from 'react';
import { Box, Container, makeStyles, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import Image from 'next/image';

interface ProjectsTextArrayProps {
  title: string;
  firstParagraph: string;
  image?: string;
  lastParagraph?: string;
  hasDivider?: boolean;
  alignCenter?: boolean;
  hasMargin?: boolean;
  blackTitle?: boolean;
  listItems?: Array<{ text: string }>;
  blackText?: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      margin: theme.spacing(7, 0, 0),
    },
    marginTop: {
      marginTop: theme.spacing(12),
      [theme.breakpoints.up('md')]: {
        marginTop: theme.spacing(18),
      },
    },
    divider: {
      width: 280,
      height: 4,
      backgroundColor: theme.palette.primary.main,
      marginBottom: theme.spacing(10),
      marginTop: theme.spacing(5),
    },
    dividerCenter: {
      width: 280,
      height: 4,
      backgroundColor: theme.palette.primary.main,
      margin: theme.spacing(5, 'auto'),
    },
    title: {
      fontWeight: 700,
      fontSize: 32,
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(5),
      [theme.breakpoints.up('md')]: {
        fontSize: 54,
      },
    },
    blackTitle: {
      fontWeight: 700,
      fontSize: 32,
      color: `#453737`,
      marginBottom: theme.spacing(5),
      [theme.breakpoints.up('md')]: {
        fontSize: 54,
      },
    },
    blackText: {
      fontWeight: 700,
      fontSize: 32,
      color: `#453737`,
      marginBottom: theme.spacing(5),
      [theme.breakpoints.up('md')]: {
        fontSize: 54,
      },
    },
    text: {
      fontSize: 16,
      marginTop: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        fontSize: 24,
      },
    },
    ulList: {
      paddingLeft: theme.spacing(4),
      marginTop: theme.spacing(5),
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(2),
      },
    },
    liItem: {
      fontSize: 16,
      lineHeight: 1.8,
      [theme.breakpoints.up('md')]: {
        fontSize: 24,
      },
      '& span': {
        fontSize: 16,
        color: `#453737`,
        fontWeight: 700,
        [theme.breakpoints.up('md')]: {
          fontSize: 24,
        },
      },
    },
  });
});

const NavigateComplex: FC<ProjectsTextArrayProps> = (props) => {
  const {
    title,
    hasDivider = false,
    alignCenter = false,
    blackTitle = false,
    hasMargin = false,
    firstParagraph,
    lastParagraph,
    image,
    listItems,
    blackText,
  } = props;
  const classes = useStyles();
  const isMediumUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  return (
    <Box className={`${blackTitle ? classes.marginTop : classes.root}`}>
      <Box mb={hasMargin ? 14 : 0} />
      <Container fixed>
        <Typography
          className={blackTitle ? classes.blackTitle : classes.title}
          align={alignCenter && isMediumUp ? 'center' : 'left'}
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          {title}
          <span className={classes.blackTitle}>{blackText}</span>
        </Typography>
        <Typography
          className={classes.text}
          align={alignCenter && isMediumUp ? 'center' : 'left'}
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          {firstParagraph}
        </Typography>
        <Typography
          className={classes.text}
          align={alignCenter && isMediumUp ? 'center' : 'left'}
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          {lastParagraph}
        </Typography>
        {!!listItems?.length && (
          <ul className={classes.ulList} data-aos="fade-up" data-aos-duration="1500">
            {listItems.map((item, index) => (
              <li className={classes.liItem} key={index}>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        )}
        {!!hasDivider && <Box className={alignCenter && isMediumUp ? classes.dividerCenter : classes.divider} />}
        {!!image && <Image src={image} width={1400} height={500} />}
        <Box mb={hasMargin ? (isMediumUp ? 30 : 20) : 0} />
      </Container>
    </Box>
  );
};

export default NavigateComplex;
